module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1168.b4cd93da.png";